import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Download, FileText, ArrowRight } from 'lucide-react';

export const TemplateCard = ({ template, index = 0 }) => {
  return (
    <Link to={`/templates/${template.id}`} data-testid={`template-card-${template.id}`}>
      <Card 
        className={`template-card group relative bg-white border border-stone-100 rounded-xl overflow-hidden hover:shadow-float hover:border-primary-100 opacity-0 animate-fade-in`}
        style={{ animationDelay: `${index * 100}ms` }}
      >
        <CardContent className="p-0">
          {/* Preview Header */}
          <div className="bg-primary-50/50 px-5 py-4 border-b border-stone-100">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-stone-900 group-hover:text-primary transition-colors line-clamp-1">
                    {template.title}
                  </h3>
                  <p className="text-xs text-stone-500 mt-0.5">{template.category}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Preview Content */}
          <div className="px-5 py-4">
            <p className="text-sm text-stone-600 line-clamp-2 leading-relaxed mb-4">
              {template.description}
            </p>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-4">
              {template.tags.slice(0, 3).map((tag) => (
                <Badge 
                  key={tag} 
                  variant="secondary" 
                  className="bg-stone-100 text-stone-600 hover:bg-stone-200 text-xs font-normal"
                >
                  {tag}
                </Badge>
              ))}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between pt-3 border-t border-stone-100">
              <div className="flex items-center gap-1.5 text-stone-400 text-xs">
                <Download className="w-3.5 h-3.5" />
                <span>{template.download_count.toLocaleString()} downloads</span>
              </div>
              <div className="flex items-center gap-1 text-primary text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                View template
                <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};
